import React from 'react';
import Proptypes from 'prop-types';
import { getPDB } from './IORequests';
import _ from 'lodash';

/** React container used to retrieve PDB data for abinitio page */
class SaxsAbInitioPDBContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            fetched: false,
            subtraction: null,
            XYZ: null
        }

        this.getData = this.getData.bind(this);
        this.prepareRequest = this.prepareRequest.bind(this);
        this.getDamaverModel = this.getDamaverModel.bind(this);
        this.getDamfiltModel = this.getDamfiltModel.bind(this);
        this.getDammin = this.getDammin.bind(this);
    }


    render() {
        if (this.props.subtraction && !_.isEqual(this.props.subtraction, this.state.subtraction)) {
            this.getData();
        }

        return this.props.children(this.state.XYZ)
    }

    getData() {
        const onSuccess = (response) => {
            if (response.data) {
                if (response.data.models != null) {
                    let XYZ = "";
                    for (let i = 0; i < response.data.models.length; i++) {
                        XYZ = XYZ + response.data.models[i].XYZ;
                    }

                    this.setState({
                        fetching: false,
                        fetched: true,
                        XYZ: XYZ,
                        subtraction: this.props.subtraction
                    })
                }
            }
        };

        const onError = (error) => {
            console.log('error occrured in SaxsAbInitioPDBContainer');
            this.setState({
                fetching: false,
                fetched: false,
                subtraction: this.props.subtraction
            })
        }

        getPDB(this.props.token, this.props.proposal, this.prepareRequest(), null, onSuccess, onError)
        //EXI.getDataAdapter({ onSuccess: onSuccess }).saxs.model.getPDB(models[0], []);
    }

    prepareRequest() {
        /** If no models we merge all **/
        let modelsMerged = [];

        let damaverModel = this.getDamaverModel();
        if (damaverModel !== undefined) {
            damaverModel.opacity = 0.2;
            modelsMerged.push(damaverModel);
        }

        let damfiltModel = this.getDamfiltModel();
        if (damfiltModel !== undefined) {
            damfiltModel.opacity = 0.6;
            modelsMerged.push(damfiltModel);
        }

        let damminModel = this.getDammin();
        if (damminModel !== undefined) {
            damminModel.opacity = 0.8;
            modelsMerged.push(damminModel);
        }

        return modelsMerged;
    }


    getDamaverModel() {
        try {
            let modelId = this.props.subtraction.abInitioModels[0].averagedModel.modelId;
            let abInitioModelId = this.props.subtraction.abInitioModels[0].abInitioModelId;
            let title = this.props.subtraction.abInitioModels[0].averagedModel.pdbFile;
            title = title.split("/")[title.split("/").length - 1];
            return {
                type: "AVERAGED",
                modelId: modelId,
                abInitioModelId: abInitioModelId,
                color: '0xFF6600',
                title: title,
                opacity: 0.5,
                radius: 3
            };

        }
        catch (e) {
            console.log(e);
        }
    };

    getDamfiltModel() {
        try {
            let modelId = this.props.subtraction.abInitioModels[0].rapidShapeDeterminationModel.modelId;
            let abInitioModelId = this.props.subtraction.abInitioModels[0].abInitioModelId;
            let title = this.props.subtraction.abInitioModels[0].rapidShapeDeterminationModel.pdbFile;
            title = title.split("/")[title.split("/").length - 1];
            return {
                type: "RAPIDSHAPEDETERMINATIONMODEL",
                modelId: modelId,
                abInitioModelId: abInitioModelId,
                color: '0x00CC00',
                title: title,
                opacity: 0.5,
                radius: 3
            };
        }

        catch (e) {
            console.log(e);
        }
    };

    getDammin() {
        try {
            let modelId = this.props.subtraction.abInitioModels[0].shapeDeterminationModel.modelId;
            let abInitioModelId = this.props.subtraction.abInitioModels[0].abInitioModelId;
            let title = this.props.subtraction.abInitioModels[0].shapeDeterminationModel.pdbFile;
            title = title.split("/")[title.split("/").length - 1];
            return {
                type: "SHAPEDETERMINATIONMODEL",
                modelId: modelId,
                abInitioModelId: abInitioModelId,
                color: '0x0099FF',
                title: title,
                opacity: 0.5,
                radius: 3
            };
        }

        catch (e) {
            console.log(e);
        }

    };
}

export default SaxsAbInitioPDBContainer;

SaxsAbInitioPDBContainer.proptypes = {
    /* Proposal name */
    proposal: Proptypes.string,
    /* the subtraction to get the data from */
    subtraction: Proptypes.object,
    /* IsPyb authentication token */
    token: Proptypes.string,

}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsAbInitioPDBContainer.js